module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_pp1_5012.e2ecbe7f.png";